import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
export const Segment = styled.h4`
  color: ${({ theme }) => theme.colors.white};
  font-size: 2rem;
  margin-top: 1rem;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.yellow};
  font-size: 4rem;
  text-transform: uppercase;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.white};
  margin-top: 1rem;
  white-space: pre-line;
`;

export const VideoData = styled.div`
  width: 660px;
`;

export const Divider = styled.div`
  width: 100%;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.white};
`;
